export const UPDATE_PERSONAL_DATA = "UPDATE_PERSONAL_DATA";
export const UPDATE_DRAWER_STATE = "UPDATE_DRAWER_STATE";
export const UPDATE_EDUCATION_STATE = "UPDATE_EDUCATION_STATE";
export const UPDATE_EDUCATION_ORDER = "UPDATE_EDUCATION_ORDER";
export const UPDATE_EXPERIENCE_STATE = "UPDATE_EXPERIENCE_STATE";
export const UPDATE_EXPERIENCE_ORDER = "UPDATE_EXPERIENCE_ORDER";
export const UPDATE_EXTRA_STATE = "UPDATE_EXTRA_STATE";
export const UPDATE_EXTRA_ORDER = "UPDATE_EXTRA_ORDER";
